var nodes = [];

var navObj = function navObj(state, params) {
    return {
        state: state,
        params: params
    };
};

var nodeObj = function nodeObj(to, toParams, from, fromParams) {
    return {
        to: navObj(to, toParams),
        from: navObj(from, fromParams)
    };
};

var addNodeToHistory = function addNodeToHistory(node) {
    var to = node.to.state.name;
    if (nodes.length > 0) {
        if (nodes[0].from.state.name === to) {
            nodes.shift();
        } else {
            nodes.unshift(node);
        }
    } else {
        nodes.unshift(node);
    }
};

export default [function () {
    return {
        updateHistory: function updateHistory(to, toParams, from, fromParams) {
            var node = nodeObj(to, toParams, from, fromParams);
            if (!from.abstract) {
                addNodeToHistory(node);
            }
        },
        recentHistory: function recentHistory() {
            return nodes.length > 0 ? nodes[0] : null;
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/navigation/NavigationService.js
// module id = 1919
// module chunks = 0